<div class="row page-title">
  <span>{{ localizationConstants.CONTRACTS_PAGE_TITLE | translate }}</span>
</div>
<div [hidden]="!dataSource.data">
  <div
    *ngIf="!dataSource.data?.length"
    class="row center">
    <div class="col">
      <h2>{{ "contracts.nocontractsfound" | translate }}</h2>
    </div>
  </div>
  <div [hidden]="!dataSource.data?.length">
    <div class="row">
      <div class="col">
        <div class="o-grid--small between u-align-center">
          <div class="o-grid__item col-12 col-md-5 col-sm-5 u-p-bottom-only u-pb--medium">
            <form class="c-search-form--full">
              <div class="c-input-group">
                <input
                  type="text"
                  name="search"
                  id="input-search"
                  [(ngModel)]="dataSource.filter"
                  class="c-input c-input--beta"
                  placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
                  required />
                <input
                  *ngIf="dataSource.filter"
                  id="contracts-search-clear"
                  (click)="dataSource.filter = ''"
                  class="c-button c-button--search c-close-search c-button--search--sm"
                  value="Clear" />
                <input
                  *ngIf="!dataSource.filter"
                  id="contracts-search"
                  type="submit"
                  class="c-button c-button--search c-button--search--sm"
                  value="Search" />
              </div>
            </form>
          </div>

          <div class="o-grid__item">
            <tool-export-button [excelExportType]="ExcelExportType.Contract"></tool-export-button>
          </div>
        </div>

        <div
          id="contract-list"
          class="col bg-white u-shadow u-scroll--horizontal">
          <ng-container
            id="tool-table"
            class="tools-table col">
            <table
              mat-table
              matSort
              [dataSource]="dataSource"
              class="c-table">
              <ng-container
                *ngFor="let col of columns"
                [matColumnDef]="col.key">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  class="c-table__column-title">
                  {{ col.title | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let item"
                  class="c-clickable"
                  [routerLink]="[
                    routeNameConstants.CONTRACTS_DETAILS_BASE,
                    item.companyId,
                    item.contractReference,
                  ]">
                  <ng-container [ngSwitch]="col.key">
                    <div *ngSwitchCase="'type'">
                      <span *ngIf="!userVisible">{{ item.type }}</span>
                    </div>
                    <div *ngSwitchCase="'startDate'">
                      {{ item.startDate | date }}
                    </div>
                    <div
                      *ngSwitchCase="'endDate'"
                      [class.c-badge]="item.isExpired">
                      {{ item.endDate | date }}
                    </div>
                    <div *ngSwitchCase="'isActive'">
                      {{ (item.isActive ? "contract.active" : "contract.notactive") | translate }}
                    </div>
                    <div *ngSwitchDefault>
                      {{ item[col.key] }}
                    </div>
                  </ng-container>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="columnKeys"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnKeys"
                class="c-table__row"></tr>
            </table>
            <div class="c-pagination--desktop">
              <div class="col-12">
                <mat-paginator
                  [showFirstLastButtons]="true"
                  [pageSize]="pageSize"
                  [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
